// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c-pointer{cursor:pointer}`, "",{"version":3,"sources":["webpack://./ClientApp/components/kanban/modal/attributes/display/systemattribute/ActivityAttribute.vue"],"names":[],"mappings":"AACA,WACE,cAAA","sourcesContent":["\r\n.c-pointer {\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
